import { useCookies } from "react-cookie";
import type { CookieKeyType } from "types/cookie";

const useCookie = (dependencyArr: CookieKeyType[]) => {
  return useCookies([...dependencyArr]);
};

export default useCookie;
